import { ErrorHandler } from 'app/_services/error-handler.factory';
import * as angular from 'angular';

class NetworkPointDetailsContractPositionsCtrl implements ng.IController {
    public networkPointId: number;
    public uiLoadingContracts: boolean = true;
    public contracts: any = [];
    public contractPositionsSortAscending = true;
    public contractPositionsSortColumn = 'legalContractPositionId'; //'contractId'
    public paginator: any = {
        contracts: {
            identificationName: 'contracts',
            itemsPerPage: 10,
            start: 0
        }
    };
    public param: any = {
        networkPointId: this.networkPointId,
        pageSize: this.paginator.contracts.itemsPerPage,
        start: this.paginator.contracts.start,
        sortColumn: this.contractPositionsSortColumn,
        sortAscending: this.contractPositionsSortAscending
    };

    constructor(
        private Fcfs,
        private errorHandler: ErrorHandler,
        public DATES
    ) {}

    $onInit(): void {
        this.getContactsPosition(this.param);
    }

    public getContactsPosition(param) {
        this.uiLoadingContracts = true;

        angular.extend(this.param, {
            pageSize: this.paginator.contracts.itemsPerPage,
            start: this.paginator.contracts.start
        });

        this.Fcfs.legalContractPositions(
            param,
            (res) => {
                this.contracts = res;
                this.uiLoadingContracts = false;
            },
            this.errorHandler
        );
    }

    public setContactPositionSortBy(value) {
        if (this.param.sortAscending && this.param.sortColumn == value) {
            this.param.sortAscending = false;
        } else {
            this.param.sortAscending = true;
        }
        this.param.sortColumn = value;
        this.getContactsPosition(this.param);
    }

    public changePage(newPageNumber) {
        this.paginator.start =
            (newPageNumber - 1) * this.paginator.contracts.itemsPerPage;
        if (this.paginator.start !== this.paginator.contracts.start) {
            this.paginator.contracts.start = this.paginator.start;
            this.getContactsPosition(this.param);
        }
    }
}
angular.module('app').component('pkpNetworkPointDetailsContractPositions', {
    controller: NetworkPointDetailsContractPositionsCtrl,
    template:
        require('app/network-point/network-point-details-contract-positions.component.html'),
    bindings: {
        networkPointId: '<'
    }
});
